import React from "react";
import "./CSS/Dekhava.css";
import mainImage from "./IMAGES/1001088643 1.png"; 
import img from "../Components/IMAGES/WhatsApp Image 2025-08-30 at 12.32.18_a62f8820.jpg"
import img2 from "./IMAGES/WhatsApp Image 2025-08-30 at 12.32.21_fa6d6ab0.jpg"

const Poster = () => {
  return (
    <div className="poster-container">
      <h2 className="poster-title">सर्वोत्कृष्ट सामाजिक देखावा </h2>
      {/* <p className="poster-description">
        सातारा शहर व तालुक्यातील सन २०१३ मध्ये संपन्न झालेल्या मोरया २०१३ या स्पर्धे मध्ये सर्वोत्कृष्ट सामाजिक देखावा या विभाग मध्ये पहिला क्रमांक मिळवला.
      </p> */}

      <div className="poster-card">
         
        <img src={mainImage} alt="Poster Main" className="poster-image" />
       <img src={img} alt="Poster Main" className="poster-image" />
        <img src={img2} alt="Poster Main" className="poster-image" />
      </div>
    </div>
  );
};

export default Poster;
